/**
 * 碰撞救援设置
 */
import { COLLISIONSETTING } from '../types';

export default {
    name: `${COLLISIONSETTING}`,
    path: '/collisionSetting',
    component: () => import(/* webpackChunkName: 'collisionSetting' */ '@/views/collisionSetting/'),
    redirect: { name: `${COLLISIONSETTING}Index` },
    meta: {
        title: '设置',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${COLLISIONSETTING}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'collisionSetting' */ '@/views/collisionSetting/home/Home.vue'),
        },
    ],
};
